import { render } from "./Geet.vue?vue&type=template&id=94a2206e&scoped=true"
import script from "./Geet.vue?vue&type=script&lang=js"
export * from "./Geet.vue?vue&type=script&lang=js"

import "./Geet.vue?vue&type=style&index=0&id=94a2206e&lang=scss&scoped=true"

import exportComponent from "/data/web/pay/thpay/thpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94a2206e"]])

export default __exports__